/**
 * Deliverables, inputs, and the derived attachment count.
 */

export function useTaskLists(localSprint, setLocalSprint, recordAction) {
  const handleDeliverablesChange = (taskId, deliverables) => {
    const task = localSprint?.tasks?.find(t => t.id === taskId);
    const oldDeliverables = task?.deliverables || [];

    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      return {
        ...prev,
        tasks: tasks.map(t => 
          t.id === taskId ? { ...t, deliverables, updatedAt: new Date().toISOString() } : t
        ),
      };
    });

    if (recordAction) {
      const taskName = task?.name || 'Task';
      recordAction({
        type: 'CHANGE_DELIVERABLES',
        description: `${taskName}: Deliverables changed`,
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, deliverables: oldDeliverables } : t),
            };
          });
        },
        redo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, deliverables } : t),
            };
          });
        },
      });
    }
  };

  const handleInputsChange = (taskId, inputs) => {
    const task = localSprint?.tasks?.find(t => t.id === taskId);
    const oldInputs = task?.inputs || [];

    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      return {
        ...prev,
        tasks: tasks.map(t => 
          t.id === taskId ? { ...t, inputs, updatedAt: new Date().toISOString() } : t
        ),
      };
    });

    if (recordAction) {
      const taskName = task?.name || 'Task';
      recordAction({
        type: 'CHANGE_INPUTS',
        description: `${taskName}: Inputs changed`,
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, inputs: oldInputs } : t),
            };
          });
        },
        redo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, inputs } : t),
            };
          });
        },
      });
    }
  };

  const handleAttachmentCountChange = (taskId, attachmentCount) => {
    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      return {
        ...prev,
        tasks: tasks.map(t => 
          t.id === taskId ? { ...t, attachmentCount, updatedAt: new Date().toISOString() } : t
        ),
      };
    });
    // No undo for attachment count - it's derived from actual file uploads
  };

  return {
    handleDeliverablesChange,
    handleInputsChange,
    handleAttachmentCountChange,
  };
}
